
export const prixFormat = (prix: number | ""): string => {

    return (
        prix?.toString().replace(
            /(.)(?=(\d{3})+$)/g,
            "$1 "
          )
    )
}